import { Outlet } from 'react-router-dom';
import {
  CommandPalette,
  CommandPaletteProvider,
  useCommandPalette,
} from '@/components/command-palette';
import { Footer } from '@/components/shared/Footer';
import { Header } from '@/components/shared/Header';
import { ScrollRestoration } from '@/components/shared/ScrollRestoration';
import { Sidebar } from '@/components/shared/Sidebar';
import { SidebarProvider, useSidebar } from '@/context/SidebarContext';
import { cn } from '@/lib/utils';

function DashboardLayoutInner() {
  const { collapsed } = useSidebar();
  const { setOpen } = useCommandPalette();

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <div
        className={cn(
          'shrink-0 overflow-hidden transition-[width] duration-200 ease-in-out hidden md:block',
          collapsed ? 'w-14' : 'w-[220px] lg:w-64'
        )}
      >
        <Sidebar />
      </div>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <ScrollRestoration />
        <Header onCommandOpen={() => setOpen(true)} />
        <main id="main-content-area" className="min-h-0 flex-1 overflow-y-auto p-4 lg:p-6">
          <div className="flex min-h-full flex-col">
            <div className="flex-1">
              <Outlet />
            </div>
            <Footer className="mt-8 border-t" />
          </div>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <SidebarProvider>
      <CommandPaletteProvider>
        <DashboardLayoutInner />
      </CommandPaletteProvider>
    </SidebarProvider>
  );
}
